import { Route } from 'react-router-dom';
import { getSessionData, getSessionStatus } from '../session/auth.js';
import { useQuery } from '../shared/useQuery.js';
import { setURLParams } from './playwithroutes.js';
import routes from './routes.json';

const route = routes.approutes;

export default function SessionRoute({ component: Component, ...rest }) {

  let sessStatus = getSessionStatus()

  let sessData = getSessionData();
  let subsName = sessData?.subscription?.plan_type;

  let req_redirect = useQuery().get('req_redirect');
  let plan_id = useQuery().get('plan_id');

  let redirectUrl = plan_id ? 
                          subsName == 'basic' && sessData.role != 'view_only' ? 
                            `${setURLParams(route.sub.subscription.payment, plan_id)}?req_ref=signup` 
                            : route.sub.subscription.details 
                          : 
                          req_redirect && req_redirect === 'plan_upgrade' ? 
                            route.sub.subscription.details 
                            : setURLParams(route.main.dashboard, 'child');

  let login_type = useQuery().get('type');
  if (login_type == 'impersonate'){
    sessStatus = false;
    console.log('session status:' , sessStatus);
  }

  return (
    <Route {...rest} render={(props) => (
      sessStatus ? 
      window.location.assign(redirectUrl) : <Component {...props} />
    )}/>
  )
}